import { Config } from '../config';
import { EventsFilter, Fleet } from '../interfaces';
import {
  DailyEvents,
  EventsByBus,
  EventsByParkedTime,
  EventsByType,
  EventsPerBus,
  EventsPerDay,
  EventsPerHour,
  EventsPerParkedTime,
  EventsPerType,
  HourlyEvents,
  RepeatObservations,
  RepeatOffences,
} from '../interfaces/insight';
import { HttpService } from './http.service';

import { EventsService } from '.';

const path = `${Config.APIv2}/insight`;
export abstract class InsightService {
  public static getObservationsByDay = (fleet: Fleet, filter: EventsFilter): Promise<DailyEvents[]> => {
    const filters = EventsService.sanitizeFilters(filter, fleet.timezone, true);

    return HttpService.fetchAuthorized(`${path}/${fleet.uuid}/events/day`, {
      method: 'POST',
      body: JSON.stringify(filters),
    }).then((res: EventsPerDay) => res.event_data || []);
  };

  public static getObservationsByHour = (fleet: Fleet, filter: EventsFilter): Promise<HourlyEvents[]> => {
    const filters = EventsService.sanitizeFilters(filter, fleet.timezone, true);

    return HttpService.fetchAuthorized(`${path}/${fleet.uuid}/events/hour`, {
      method: 'POST',
      body: JSON.stringify(filters),
    }).then((res: EventsPerHour) => res.event_data || []);
  };

  public static getObservationsByBus = (fleet: Fleet, filter: EventsFilter): Promise<EventsByBus[]> => {
    const filters = EventsService.sanitizeFilters(filter, fleet.timezone, true);

    return HttpService.fetchAuthorized(`${path}/${fleet.uuid}/events/bus`, {
      method: 'POST',
      body: JSON.stringify(filters),
    }).then((res: EventsPerBus) => res.event_data || []);
  };

  public static getRepeatOffencesSnapshot = (fleet: Fleet, filter: EventsFilter): Promise<RepeatOffences[]> => {
    const filters = EventsService.sanitizeFilters(filter, fleet.timezone, true);

    return HttpService.fetchAuthorized(`${path}/${fleet.uuid}/events/repeat/count`, {
      method: 'POST',
      body: JSON.stringify(filters),
    }).then((res: RepeatObservations) => res.event_data || []);
  };

  public static getObservationsByType = (fleet: Fleet, filter: EventsFilter): Promise<EventsByType[]> => {
    const filters = EventsService.sanitizeFilters(filter, fleet.timezone, true);

    return HttpService.fetchAuthorized(`${path}/${fleet.uuid}/events/type`, {
      method: 'POST',
      body: JSON.stringify(filters),
    }).then((res: EventsPerType) => res.event_data || []);
  };

  public static getObservationParkedTime = (fleet: Fleet, filter: EventsFilter): Promise<EventsByParkedTime[]> => {
    const filters = EventsService.sanitizeFilters(filter, fleet.timezone, true);

    return HttpService.fetchAuthorized(`${path}/${fleet.uuid}/events/parked/time`, {
      method: 'POST',
      body: JSON.stringify(filters),
    }).then((res: EventsPerParkedTime) => res.event_data || []);
  };
}
